/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiClassificationFromJSON, ApiClassificationToJSON, } from './ApiClassification';
import { ApiClassificationRuleFromJSON, ApiClassificationRuleToJSON, } from './ApiClassificationRule';
import { ApiStatusFromJSON, ApiStatusToJSON, } from './ApiStatus';
export function ApiClassificationItemFromJSON(json) {
    return ApiClassificationItemFromJSONTyped(json, false);
}
export function ApiClassificationItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'classification': !exists(json, 'classification') ? undefined : ApiClassificationFromJSON(json['classification']),
        'classificationId': !exists(json, 'classificationId') ? undefined : json['classificationId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'param': !exists(json, 'param') ? undefined : json['param'],
        'rules': !exists(json, 'rules') ? undefined : (json['rules'].map(ApiClassificationRuleFromJSON)),
        'status': !exists(json, 'status') ? undefined : ApiStatusFromJSON(json['status']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiClassificationItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'classification': ApiClassificationToJSON(value.classification),
        'classificationId': value.classificationId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'description': value.description,
        'id': value.id,
        'order': value.order,
        'param': value.param,
        'rules': value.rules === undefined ? undefined : (value.rules.map(ApiClassificationRuleToJSON)),
        'status': ApiStatusToJSON(value.status),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'value': value.value,
    };
}
